import { z } from "zod";

export const formSchema = z.object({
	firstName: z
		.string()
		.min(1, "First name is required.")
		.max(50, "First name cannot exceed 50 characters.")
		.trim(),
	lastName: z
		.string()
		.min(1, "Last name is required.")
		.max(50, "Last name cannot exceed 50 characters.")
		.trim(),
	email: z.string().trim(),
	phone: z
		.string()
		.regex(/^\d+$/, "Phone number must contain only numbers.")
		.trim()
		.optional(),
});
